import React from 'react';
import { Stack, Button } from '@mui/material';
import Modal from '@mui/material/Modal';

import { useAppDispatch, useAppSelector } from 'redux/hooks/reduxHooks';
import { selectCurrentModal, selectSpecialPage } from 'redux/selectors/selectors';
import { openCurrentModal, closeCurrentModal } from 'redux/slices/modals/modals.slice';
import { EModalsNames } from 'shared/types/modal.interface';

import { useCheckPage } from 'shared/hooks/useCheckPage';

import { urls } from 'shared/constants/routing.constants';
import { HEADER_BUTTONS, CLOSE } from 'shared/constants/buttons-constants';
import { CustomMuiIcon } from 'assets/images/icons/customMuiIcons';

export const MobileDebateCreationModal: React.FC = () => {
  const currentModal = useAppSelector(selectCurrentModal);
  const currentPage = useAppSelector(selectSpecialPage);
  const dispatch = useAppDispatch();

  const checkPage = useCheckPage(currentPage);

  const handleOnClose = () => {
    dispatch(closeCurrentModal());
  };

  if (currentModal.entityName !== EModalsNames.CreateDebateOptions) return null;

  return (
    <Modal
      onClose={handleOnClose}
      open={currentModal.entityName === EModalsNames.CreateDebateOptions}
      sx={{
        alignItems: 'flex-end',
        bottom: '40px',
        display: { xs: 'flex', md: 'none' },
      }}
      closeAfterTransition
    >
      <Stack
        sx={{
          width: 'calc(100% - 44px)',
          borderRadius: '8px',
          padding: '24px',
          backgroundColor: 'primary.contrastText',
          rowGap: '6px',
        }}
      >
        <Button
          variant="defaultLight"
          onClick={() => {
            checkPage(urls.commonPages.generateTopics);
            handleOnClose();
          }}
          sx={{ backgroundColor: 'myGrey.grey100' }}
        >
          <CustomMuiIcon type="icon-create-with-AI" />
          {HEADER_BUTTONS.createWithAI}
        </Button>
        <Button
          variant="autoSize"
          onClick={() => {
            dispatch(openCurrentModal({ popupName: EModalsNames.CreateDebate }));
          }}
        >
          {HEADER_BUTTONS.startYourDebate}
        </Button>
        <Button
          variant="transparent"
          onClick={handleOnClose}
          sx={{ '&:hover': { backgroundColor: 'transparent' } }}
        >
          {CLOSE}
        </Button>
      </Stack>
    </Modal>
  );
};
